var JourneyPlannerDateTime = (function(){
  'use strict';

  var inputDatePicker = $("#jp-date");
  var inputTimePicker = $("#jp-time");
  var inputHour = $("#jp-hour");
  var inputMinute = $("#jp-minute");
  var now;

  var disablePastHours = function() {

    if (Utils.isMobileOrTablet()){
      inputTimePicker.prop('min', moment(now).format('HH:mm'));
    }
    else {
      inputHour.find('option').each(function() {
        $(this).prop('disabled', $(this).val() < now.getHours());
      });

      inputMinute.find('option').each(function() {
        $(this).prop('disabled', inputHour.val() <= now.getHours() && $(this).val() < now.getMinutes());
      });
    }
  };

  var enableAllHours = function() {

    if (Utils.isMobileOrTablet()){
      // Update time range (not supported by iOS/Safari)
      inputTimePicker.prop('min', moment(now).startOf('day').format('HH:mm'));
    }
    else {
      inputHour.find('option').each(function() {
        $(this).prop('disabled', false);
      });

      inputMinute.find('option').each(function() {
        $(this).prop('disabled', false);
      });
    }
  };

  var getSelectedDate = function() {

    var dateSelected = new Date();

    if (inputDatePicker.val() !== '') {

      if (Utils.isMobileOrTablet()) {
        dateSelected = inputDatePicker.val();
      } else {
        dateSelected = Utils.convertFrenchDateToIso(inputDatePicker.val());
      }
    }

    return dateSelected;
  };

  var setSelectedDate = function(dateSelected) {

    if (Utils.isMobileOrTablet()) {
      inputDatePicker.val(moment(dateSelected).format('YYYY-MM-DD'));
    }
    else {
      inputDatePicker.val(moment(dateSelected).format('DD/MM/YYYY'));
    }
  };

  var getSelectedTime = function() {

    var timeSelected = new Date();

    if (Utils.isMobileOrTablet()) {
      timeSelected = moment(inputTimePicker.val(), 'HH:mm').toDate();
    }
    else {
      timeSelected.setHours(inputHour.val());
      timeSelected.setMinutes(inputMinute.val());
    }

    timeSelected.setSeconds(0);
    timeSelected.setMilliseconds(0);

    return timeSelected;
  };

  var setSelectedTime = function(timeSelected) {
    if (Utils.isMobileOrTablet()) {

      // Update time range (not supported by iOS/Safari)
      if (moment(inputDatePicker.val()).isSame(now, "day")) {
        inputTimePicker.prop('min', moment(now).format('HH:mm'));
      }
      else {
        inputTimePicker.prop('min', moment().startOf('day').format('HH:mm'));
      }

      inputTimePicker.val(moment(timeSelected).format('HH:mm'));
    }
    else {
      inputHour.val(timeSelected.getHours());
      inputMinute.val(timeSelected.getMinutes());
    }
  };

  var roundTimeToNextFiveMinutes = function(time){
    var mins = Math.ceil(time.getMinutes()/5) * 5;
    time.setMinutes(mins);
    time.setSeconds(0);
    time.setMilliseconds(0);
    return time;
  };

  var updateNow = function() {
    now = roundTimeToNextFiveMinutes(new Date());

    var dateSelected = getSelectedDate();
    var timeSelected = getSelectedTime();

    // Do not allow past dates (use cases: iOS not supporting range attribute for HTML5 input dates, midnight)
    if (moment(dateSelected).isBefore(now, "day")) {
        setSelectedDate(now);
        setSelectedTime(now);
        enableAllHours();
    }
    else {
      // Do not allow past hours (use case : wait minutes before submitting without making time change)
      if (moment(dateSelected).isSame(now, "day")) {
        setSelectedDate(now);

        if (moment(timeSelected).isBefore(moment(now))){
          setSelectedTime(now);
        }

        disablePastHours();
      }
      else {
        enableAllHours();
      }
    }
  };

  var getNow = function() {
    return now;
  };

  return {
    updateNow: updateNow,
    getNow: getNow,
    getSelectedDate: getSelectedDate,
    setSelectedDate: setSelectedDate,
    getSelectedTime: getSelectedTime,
    setSelectedTime: setSelectedTime,
    init: function() {
      now = roundTimeToNextFiveMinutes(new Date());

      if (Utils.isMobileOrTablet()) {

        // Use HTML5 date input fields only for mobiles & tablets
        inputDatePicker.val(moment(now).format('YYYY-MM-DD'));
        inputDatePicker.prop('min', moment(now).format('YYYY-MM-DD'));
        inputDatePicker.prop('max', moment(now).add('days', 57).format('YYYY-MM-DD'));

        inputTimePicker.val(moment(now).format('HH:mm'));
        inputTimePicker.attr('min', moment(now).format('HH:mm'));

        $('#journey-planner-map-control').find('.hour-minute-group').addClass('is-hidden');

      } else {

        $.datepicker.regional.fr = {
          closeText: 'Fermer',
          prevText: 'Précédent',
          nextText: 'Suivant',
          currentText: 'Aujourd\'hui',
          monthNames: ['Janvier','Fevrier','Mars','Avril','Mai','Juin',
          'Juillet','Aout','Septembre','Octobre','Novembre','Decembre'],
          monthNamesShort: ['Jan','Fev','Mar','Avr','Mai','Jun',
          'Jul','Aou','Sep','Oct','Nov','Dec'],
          dayNames: ['Dimanche','Lundi','Mardi','Mercredi','Jeudi','Vendredi','Samedi'],
          dayNamesShort: ['Dim','Lun','Mar','Mer','Jeu','Ven','Sam'],
          dayNamesMin: ['Di','Lu','Ma','Me','Je','Ve','Sa'],
          weekHeader: 'Sm',
          dateFormat: 'dd/mm/yy',
          firstDay: 1,
          showMonthAfterYear: false,
        };

        if ($('html').attr('lang') === 'fr-FR') {
          $.datepicker.setDefaults($.datepicker.regional.fr);
        }

        inputDatePicker.prop('type', 'text');
        inputDatePicker.datepicker({
          dateFormat: 'dd/mm/yy',
          minDate: '0',
          maxDate: "+57d",
          language: "fr",
          firstDay: 1
        }).datepicker("setDate", now).change(function () {});

        $('#journey-planner-map-control').find('.time-group').addClass('is-hidden');
        inputHour.find('option[value="' + now.getHours() + '"]').prop('selected', true);
        inputMinute.find('option[value="' + now.getMinutes() + '"]').prop('selected', true);

        disablePastHours();
      }

      inputHour.change(function() {
        updateNow();
      });

      inputMinute.change(function() {
        updateNow();
      });

      inputTimePicker.change(function() {
        updateNow();
      });

      inputDatePicker.change(function() {
        updateNow();
      });
    }
  };

}());
